/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React from 'react'
import { BaseLayout, ListViewLayout } from 'ui-library/dist/external/layouts'
import { DataTable, DataTableColumn as TD, DataTableHeader as TH, DataTableRow as TR, NavigationDrawer, Pagination } from 'ui-library/dist/external/components'
import ActivityAction from '../../../action/activity'
import Money from '../../unit/Money'

function ListView(props) {
  const toolbar = { label: `アクティビティ一覧`, items: props.accountMenu }
  const pagination = props.pagination

  const searchFunction = params => {
    const pagination = props.pagination.merge({ page: params.page, per_page: params.perPage })
    console.log(pagination)
    ActivityAction.onSearch(pagination)
  }

  return (
    <>
      <NavigationDrawer toolbar={toolbar} navigations={props.navigations} />

      <BaseLayout>
        <ListViewLayout>
          <DataTable
            headers={[
              <TH key={1} width="5%" isNumber>
                ID
              </TH>,
              <TH key={2} width="55%">
                名称
              </TH>,
              <TH key={3} width="20%" isNumber>
                単価
              </TH>,
              <TH key={4} width="20%">
                販売方法
              </TH>
            ]}
            rows={props.activities.map(activity => (
              <TR key={activity.id}>
                <TD isNumber>{activity.id}</TD>
                <TD>{activity.name}</TD>
                <TD isNumber>
                  <Money>{activity.unit_price}</Money>
                </TD>
                <TD>{saleUnit(activity.sale_unit)}</TD>
              </TR>
            ))}
          />
        </ListViewLayout>
        <Pagination
          name="pagination"
          perPage={props.pagination.per_page}
          total={props.pagination.total}
          page={props.pagination.page}
          prev={e => searchFunction(e.value)}
          next={e => searchFunction(e.value)}
          perPageChanged={e => searchFunction(e.value)}
        />
      </BaseLayout>
    </>
  )
}

function saleUnit(value) {
  switch (value) {
    case 'people_stay':
      return '一泊一人あたり'
    case 'people':
      return '一人あたり'
    case 'stay':
      return '一泊あたり'
    case 'once':
      return '一括'
    default:
      return '(none)'
  }
}

export default ListView
